import React, {useState} from "react";

const Skeleton = () => {
   
    return (
        <div className="col-xl-3 col-sm-6 py-2" >
            <div className="card-data skeleton skeleton-text"></div>
        </div>
    )
}

export default Skeleton;